import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/view/welcomePage/welcomePage'
import homePage from '@/view/homePage/homePage'
import news from '@/view/news/news'
import newsdetail from '@/view/news/newsdetail'
import Login from '@/view/Login/index'
import Forget from '@/view/Login/Forget'
import register from '@/view/Login/register'
import match from '@/view/Match/index'
import matchinte from '@/view/Match/matchinte'
import boc from '@/view/Match/boc'
import Export from '@/view/Export/index'
import Work from '@/view/Work/index'
import wordList from '@/view/Work/list'
import Signup from '@/view/Signup/index'
import workspace from '@/view/Match/workspace'
import proposition from '@/view/Match/proposition'
import wordDetail from '@/view/Work/wordDetail'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [{
        path: '/welcomePage',
        component: HelloWorld,
        hidden: true,
        children: [{
            path: 'welcomePage',
            name: "welcomePage",
            component: resolve => require(['@/view/welcomePage/welcomePage'], resolve)
        }]
    }, {
        path: '/',
        component: homePage,
        hidden: true,
        children: [{
            path: 'homePage',
            name: "homePage",
            component: resolve => require(['@/view/homePage/homePage'], resolve)
        }]
    }, {
        path: '/news',
        component: news,
        hidden: true,
    }, {
        path: '/news/newsdetail',
        component: newsdetail,
        hidden: true,
    },
    {
        path: '/Login',
        component: Login,
        hidden: true,
        children: [{
            path: 'Login',
            name: "Login",
            component: resolve => require(['@/view/Login/index'], resolve)
        }]
    }, {
        path: '/Forget',
        component: Forget,
        hidden: true,
        children: [{
            path: 'Forget',
            name: "Forget",
            component: resolve => require(['@/view/Login/Forget'], resolve)
        }]
    }, {
        path: '/register',
        component: register,
        hidden: true,
        children: [{
            path: 'register',
            name: "register",
            component: resolve => require(['@/view/Login/register'], resolve)
        }]
    }, {
        path: '/match',
        component: match,
        hidden: true,
        children: [{
            path: 'match',
            name: "match",
            component: resolve => require(['@/view/Match/index'], resolve)
        }]
    }, {
    path: '/boc',
    component: boc,
    hidden: true,
    children: [{
      path: 'boc',
      name: "boc",
      component: resolve => require(['@/view/Match/boc'], resolve)
    }]
  }, {
    path: '/matchinte',
    component: matchinte,
    hidden: true,
    children: [{
      path: 'matchinte',
      name: "matchinte",
      component: resolve => require(['@/view/Match/matchinte'], resolve)
    }]
  }, {
        path: '/Export',
        component: Export,
        hidden: true,
        children: [{
            path: 'Export',
            name: "Export",
            component: resolve => require(['@/view/Export/index'], resolve)
        }]
    }, {
        path: '/Work',
        component: Work,
        hidden: true,
        children: [{
            path: 'Work',
            name: "Work",
            component: resolve => require(['@/view/Work/index'], resolve)
        }]
    }, {
        path: '/Signup',
        component: Signup,
        hidden: true,
        children: [{
            path: 'Signup',
            name: "Signup",
            component: resolve => require(['@/view/Signup/index'], resolve)
        }]
    }, {
        path: '/workspace',
        component: workspace,
        hidden: true,
        children: [{
            path: 'workspace',
            name: "workspace",
            component: resolve => require(['@/view/Match/workspace'], resolve)
        }]
    },{
        path: '/newscontact',
        component: resolve => require(['@/view/news/newscontact'], resolve),
    },{
    path: '/newsnote',
    component: resolve => require(['@/view/news/newsnote'], resolve),
  },{
    path: '/newsreport',
    component: resolve => require(['@/view/news/newsreport'], resolve),
  },{
    path: '/newscity',
    component: resolve => require(['@/view/news/newscity'], resolve),
  },{
    path: '/newstopic',
    component: resolve => require(['@/view/news/newstopic'], resolve),
  },{
    path: '/design',
    component: resolve => require(['@/view/Match/design'], resolve),
  },
    {
        path: '/industrial',
        component: resolve => require(['@/view/Match/industrial'], resolve),
    },
    {
        path: '/innovate',
        component: resolve => require(['@/view/Match/innovate'], resolve),
    }, {
        path: '/proposition',
        component: proposition,
        hidden: true,
        children: [{
            path: 'proposition',
            name: "proposition",
            component: resolve => require(['@/view/Match/proposition'], resolve)
        }]
    }, {
    path: '/Work/wordDetail',
    component: wordDetail,
    hidden: true,
    children: [{
      path: 'wordDetail',
      name: "wordDetail",
      component: resolve => require(['@/view/Work/wordDetail'], resolve)
    }]
  },{
    path: '/Work/list',
    component: wordList,
    hidden: true,
    children: [{
      path: 'wordList',
      name: "wordList",
      component: resolve => require(['@/view/Work/wordDetail'], resolve)
    }]
  }

]

export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js